import { createSelector } from 'reselect';
import { RootState } from 'store/types';
import { startedFlowTimeStampSelector } from 'store/amwell/activity/selectors';

export const healthDocumentsStateSelector = (state: RootState) =>
  state.amwell.activeConsumer.healthDocuments;

export const healthDocumentsSelector = createSelector(
  [healthDocumentsStateSelector, startedFlowTimeStampSelector],
  (hd, startedAmwellActivity) =>
    hd.data.filter(doc => startedAmwellActivity?.isBefore(doc.uploadDate)) || []
);

export const healthDocumentsErrorSelector = createSelector(
  healthDocumentsStateSelector,
  hd => hd.errors
);

export const healthDocumentsLoadingSelector = createSelector(
  healthDocumentsStateSelector,
  hd => hd.loading
);
